import 'arrive';
import { getConfig } from '@fec/assets/js/utils/config';

const HOOK_SELECTOR = '[data-js-plugin]';
let loadedPlugins = [];
let config = getConfig();

export function init() {
  let loadOnInit = [];
  $(HOOK_SELECTOR).each((idx, target) => {
    loadOnInit.push(...$(target).data('js-plugin').split(','));
  });
  loadPlugins(loadOnInit);
  loadedPlugins = loadOnInit;

  // load plugins for content that is added to DOM after document.ready (via ajax, websocket, ..)
  document.arrive(HOOK_SELECTOR, (target) => {
    let loadOnArrive = $(target).data('js-plugin').split(',');
    loadOnArrive = loadOnArrive.filter((p) => {
      return !loadedPlugins.includes(p);
    });
    loadPlugins(loadOnArrive);
    loadedPlugins.concat(loadOnArrive);
  });
}

function loadPlugins(plugins) {
  if (plugins.includes('audio-gallery')) {
    import('@fec/frontend-aron/modules/media/AudioGallery/index.jsx').then(
      (module) => runPlugin(module),
    );
  }

  if (plugins.includes('video-gallery')) {
    import('@fec/frontend-aron/modules/media/VideoGallery/index.jsx').then(
      (module) => runPlugin(module),
    );
  }

  if (plugins.includes('vote_map')) {
    import('@default/polis/polis-map.js').then((module) => runPlugin(module));
  }

  if (plugins.includes('meteo-collections')) {
    import('@default/meteo/js/srf-meteo-home.js').then((module) =>
      runPlugin(module),
    );
  }

  if (plugins.includes('radio-program')) {
    import('@aron/radio/radioProgram/js/index.js').then((module) =>
      runPlugin(module),
    );
  }

  if (plugins.includes('srf-song-log')) {
    import('@aron/radio/songLog/js/App.js').then((module) => runPlugin(module));
  }

  if (plugins.includes('srf-rubric-search')) {
    import('@aron/search/js/index.js').then((module) => runPlugin(module));
  }

  if (plugins.includes('woody')) {
    import('@fec/frontend/snowflakes/liveticker/index.jsx').then((module) =>
      runPlugin(module),
    );
  }

  if (plugins.includes('app-promo-banner')) {
    import(
      '@fec/frontend/snowflakes/ads/app-promo-banner/app-promo-banner.scss'
    ).then(() =>
      import(
        '@fec/frontend/snowflakes/ads/app-promo-banner/app-promo-banner.js'
      ).then((module) => runPlugin(module)),
    );
  }

  if (plugins.includes('a2z')) {
    import('@fec/frontend/modules/groups-and-lists/a2z/a2z.js').then((module) =>
      runPlugin(module),
    );
  }

  if (plugins.includes('error-page')) {
    import('@fec/frontend/modules/content/error-page/error-page.js').then(
      (module) => runPlugin(module),
    );
  }

  if (plugins.includes('formio-form')) {
    import('@default/formio/js/formio-form.js').then((module) =>
      runPlugin(module),
    );
  }

  if (plugins.includes('radio-live-player')) {
    import(
      '@fec/frontend/snowflakes/radio/radio-live-player/radio-live-player.js'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('radio-content-header')) {
    import(
      '@fec/frontend/snowflakes/radio/radio-content-header/radio-content-header.js'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('marquee')) {
    import('@fec/frontend/elements/wrappers/marquee/marquee.js').then(
      (module) => runPlugin(module),
    );
  }

  // Static item "resume_listening"
  if (plugins.includes('srf-resume-listening')) {
    import('@fec/frontend-aron/modules/resume-listening/index.jsx').then(
      (module) => runPlugin(module),
    );
  }

  // embed ElectionWidget requires special handling for links in apps
  if (
    plugins.includes('srg-election-widget') &&
    config.REPRESENTATION === 'webview'
  ) {
    import(
      '@fec/frontend/snowflakes/article/election-widget/election-widget-linkhandler.js'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('iframe-resize')) {
    import('@aron/common/srf-iframe-adjust.js').then((module) =>
      runPlugin(module),
    );
  }

  if (plugins.includes('promo-banner')) {
    import(
      '@fec/frontend/snowflakes/article/promo-banner/promo-banner.js'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('image-gallery')) {
    import(
      '@fec/frontend/modules/content/image-gallery/image-gallery.scss'
    ).then(() =>
      import(
        '@fec/frontend/modules/content/image-gallery/image-gallery.js'
      ).then((module) => runPlugin(module)),
    );
  }

  if (
    plugins.includes('open-image-in-webview') &&
    config.REPRESENTATION === 'webview'
  ) {
    import('@aron/common/bridge/image-click-webview-informer.js').then(
      (module) => runPlugin(module),
    );
  }

  if (plugins.includes('image-gallery-teaser-captions')) {
    import(
      '@fec/frontend/modules/content/image-gallery/image-gallery-teaser-captions.scss'
    ).then(() =>
      import(
        '@fec/frontend/modules/content/image-gallery/image-gallery-teaser-captions.js'
      ).then((module) => runPlugin(module)),
    );
  }

  if (plugins.includes('player-widget')) {
    // letterbox assets are preloaded below too
    import(
      '@fec/frontend-aron/modules/media/PlayerWidget/PlayerWidget.jsx'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('letterbox') || plugins.includes('player-widget')) {
    // postpone loading of large letterbox assets to the onload event
    window.addEventListener('load', () => {
      import('@srgssr/srgletterbox-web/dist/letterbox.css').then(() => {
        import('@srgssr/srgletterbox-web/dist/letterbox.js').then((module) => {
          window.SRGLetterbox = module.default;
        });
      });
    });
  }

  if (plugins.includes('autoplay-teaser')) {
    import(
      '@fec/frontend-aron/modules/media/AutoplayTeaser/AutoplayTeaser.jsx'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('scoreboard')) {
    import('@fec/frontend/modules/groups-and-lists/Scoreboard/index.tsx').then(
      (module) => runPlugin(module),
    );
  }

  if (plugins.includes('player-modal')) {
    import(
      '@fec/frontend-aron/modules/containers/PlayerModal/PlayerModal.jsx'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('related-items-list')) {
    import(
      '@fec/frontend/modules/groups-and-lists/related-items-list/RelatedItemsList.jsx'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('materialbox')) {
    import(
      '@fec/frontend/snowflakes/article/material-box/MaterialBox.jsx'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('radio-episodes')) {
    import('@aron/audio/radio-episodes/index.tsx').then((module) =>
      runPlugin(module),
    );
  }

  if (plugins.includes('legacy-font-definitions')) {
    import(
      '@fec/frontend/modules/content/embed/embed-legacy-font-definitions.scss'
    );
  }

  // inform app via bridge if any swipeable thing is on the screen at any given moment
  if (
    plugins.includes('swipey-viewport-snitch') &&
    config.REPRESENTATION === 'webview'
  ) {
    import('@aron/common/bridge/swipeys-in-viewport-snitch.js').then((module) =>
      runPlugin(module),
    );
  }

  if (plugins.includes('play-top-module')) {
    import(
      '@fec/frontend/snowflakes/landingpage/play-top-module/play-top-module.js'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('event-countdown')) {
    import(
      '@fec/frontend/modules/content/event-countdown/event-countdown.js'
    ).then((module) => runPlugin(module));
  }

  if (plugins.includes('srg-login-app')) {
    import('@aron/srg-login/index.tsx').then((module) => runPlugin(module));
  }
}

function runPlugin(plugin) {
  // Each plugin must provide an init function
  if (plugin.init && typeof plugin.init === 'function') {
    plugin.init();
  }
}
